'use client';

import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { UpgradeCard } from './upgrade-card';
import { UPGRADE_REQUIRED_EVENT, type UpgradeWallKind } from '@/lib/upgrade-wall';

type WallState = { kind: UpgradeWallKind; message: string } | null;

export function UpgradeWallProvider({ children }: { children: React.ReactNode }) {
  const [wall, setWall] = useState<WallState>(null);

  useEffect(() => {
    const show = (event: Event) => {
      const detail = (event as CustomEvent<{ kind?: UpgradeWallKind; message?: string }>).detail;
      setWall({ kind: detail?.kind ?? 'generic', message: detail?.message ?? '' });
    };
    window.addEventListener(UPGRADE_REQUIRED_EVENT, show);
    return () => window.removeEventListener(UPGRADE_REQUIRED_EVENT, show);
  }, []);

  return (
    <>
      {children}
      <Dialog open={Boolean(wall)} onOpenChange={(open) => !open && setWall(null)}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>See what your store can do on Plus</DialogTitle>
            <DialogDescription>
              Upgrade only when you need it. Free keeps your published page online.
            </DialogDescription>
          </DialogHeader>
          {wall && (
            <UpgradeCard
              kind={wall.kind}
              description={wall.message}
              onNavigate={() => setWall(null)}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
